module.exports = __webpack_public_path__ + "assets/security-82263de82248c1a7bb33c8e01ac85986.png";